var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 75.495 67.791",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "np_download_1145284_FFFFFF",
    transform: "translate(-25 -31.301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M96.72,71.2H28.775a3.775,3.775,0,0,0,0,7.549H96.72a3.775,3.775,0,0,0,0-7.549Z",
    transform: "translate(0 20.344)",
    fill: "#16192C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M69.8,62.1l-9.059,6.795V35.076a3.775,3.775,0,1,0-7.549,0V68.748l-9.059-6.641a4.053,4.053,0,0,0-2.265-.755,3.932,3.932,0,0,0-3.02,1.51,3.812,3.812,0,0,0,.755,5.285L54.858,79.317a3.635,3.635,0,0,0,4.53,0l15.1-11.171a3.812,3.812,0,0,0,.755-5.285A4.043,4.043,0,0,0,69.8,62.1Z",
    transform: "translate(6.687 0)",
    fill: "#16192C"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadLogo);
export default __webpack_public_path__ + "static/media/DownloadLogo.11dd02efbb65721bea650808a06bff36.svg";
export { ForwardRef as ReactComponent };